import { FC } from "react";
import "../CSS/CalendarScreenHeader.css";
import appIcon from "../../../assets/images/header-sabehub-app-icon.svg";
import infoIcon from "../../../assets/images/calendar-header-info-icon.svg";
import MonthYearPicker from "../../../components/elements/MonthYearPicker";
import EventsMonthYearPicker from "components/elements/EventsMonthYearPicker";
import {
  CALENDAR_RESERVATION_TABS,
  CALENDAR_RESERVATION_TYPE,
} from "utils/constants";

interface CalendarScreenHeaderProps {
  userProfileData: any;
  onlyMonthYearSelection: boolean;
  selectedDate: Date;
  setSelectedDate: (date: string) => void;
  nextAvailableDate?: Date;
  selectedTab?: string;
}

const CalendarScreenHeader: FC<CalendarScreenHeaderProps> = ({
  userProfileData,
  onlyMonthYearSelection,
  selectedDate,
  setSelectedDate,
  nextAvailableDate,
  selectedTab,
}) => {
  const getHeaderData = (): { title: string; subtitle: string } => {
    switch (selectedTab) {
      case CALENDAR_RESERVATION_TYPE.EVENTS:
        return {
          title: "Choose UR",
          subtitle: "next Experience",
        };

      case CALENDAR_RESERVATION_TYPE.RETREAT:
        return {
          title: "Choose UR",
          subtitle: "Next Retreat",
        };

      case CALENDAR_RESERVATION_TYPE.MB_STUDIO:
        return {
          title: "Choose UR",
          subtitle: "Recovery Cohort",
        };

      case CALENDAR_RESERVATION_TYPE.WORKSHOP:
        return {
          title: "Choose UR",
          subtitle: "Next Learning",
        };

      default:
        return {
          title: "Select",
          subtitle: "Work Day & Time",
        };
    }
  };

  const getDescriptionData = (): string => {
    switch (selectedTab) {
      case CALENDAR_RESERVATION_TYPE.DF_WORKSPACE:
        return "Create Space is built for the work that starts in your mind. With low lounge-style seating, a library-inspired environment, and a calmer pace, Create Space helps you move out of reaction mode and return to original thinking.";

      case CALENDAR_RESERVATION_TYPE.INNOVATE_SPACE:
        return "Innovate Space is built for focused execution. With ergonomic chairs, focused workstations, and a calm aesthetic, Innovate Space helps you work longer, think sharper, and leave with visible progress.";

      case CALENDAR_RESERVATION_TYPE.MEETING_ROOMS:
        return "Communicate Space is built for the work that needs people. From private two-person pods to small team rooms, Communicate Space gives you the privacy, tools, and setting to make conversations more focused and useful.";

      case CALENDAR_RESERVATION_TYPE.EVENTS:
        return "SabeHub hosts curated experiences for founders, business owners, who want more than casual networking. Designed to help you meet the right people, protect your energy, and build with more clarity.";

      case CALENDAR_RESERVATION_TYPE.RETREAT:
        return "Retreat is built for founders and business owners who want more than court time.Not random networking. A curated group with a shared reason to be there.";

      case CALENDAR_RESERVATION_TYPE.MB_STUDIO:
        return "Wellness is not just about intense workouts or only slow healing practices — it is about balance. Inspired by Ayurvedic philosophy, Wellness Ecosystem supports both activation and restoration.";

      case CALENDAR_RESERVATION_TYPE.WORKSHOP:
        return "Focused, hands-on sessions that give founders practical skills and immediate tools to scale smarter.";

      default:
        return "";
    }
  };

  const { title, subtitle } = getHeaderData();

  return (
    <header className="calendar-screen-header-bar">
      <div className="calendar-screen-header-left-container">
        <img src={appIcon} alt="logo" className="header-image" />
      </div>
      <div className="calendar-screen-header-divider"></div>
      <div className="calendar-screen-header-right-container">
        <div className="title-container">
          <span style={{ color: "#C1F700" }}>{title}</span>
          <span>{subtitle}</span>
        </div>
        <div className="calendar-screen-header-info-tooltip-container">
          <div className="offer-container">
            <img src={infoIcon} alt="header-info-icon" />
          </div>

          <div className="calendar-screen-header-info-tooltip-text">
            <span className="title-text">
              {CALENDAR_RESERVATION_TABS.find(
                (type) => type.value === selectedTab,
              )?.name || ""}
            </span>
            <span className="sub-title-text">{getDescriptionData()}</span>
          </div>
        </div>
        <div>
          {onlyMonthYearSelection ? (
            <EventsMonthYearPicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              setCurrentDate={onlyMonthYearSelection}
              nextAvailableDate={nextAvailableDate}
              selectedTab={selectedTab}
            />
          ) : (
            <MonthYearPicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              setCurrentDate={onlyMonthYearSelection}
              nextAvailableDate={nextAvailableDate}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default CalendarScreenHeader;
